import clsx from 'clsx'
import { MapboxMobilePositionsContext } from 'components/MapboxMap/MapboxCommon'
import { useIsMobile } from 'hooks/useIsMobile'
import { useContext } from 'react'

import style from './CenterOnStationButton.module.css'

const CenterOnStationButton = ({
  onClick,
  right,
  disabled,
}: {
  onClick: () => void
  right?: number
  disabled?: boolean
}) => {
  const isMobile = useIsMobile()
  const positions = useContext(MapboxMobilePositionsContext)
  const rightPos = right ?? positions.extra1

  return (
    <div
      className={style.root}
      onClick={!disabled ? onClick : undefined}
      style={isMobile && rightPos !== undefined ? { right: rightPos } : {}}
    >
      <button className={style.button} disabled={disabled} title="Center on station">
        <span className={clsx('mapboxgl-ctrl-icon', style.icon)} />
      </button>
    </div>
  )
}

export default CenterOnStationButton
